/**
 * @generated SignedSource<<fec8143ee7a32bf5e10ee7ab8009d4e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BadgeKind = "emoji" | "icon" | "upload" | "%future added value";
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type DashboardLayout = "one_column" | "two_column" | "%future added value";
export type FeedAllowPostsFrom = "admins" | "all" | "groups" | "%future added value";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductAppStatus = "active" | "inactive" | "%future added value";
export type ProductAppVisibility = "admin" | "all" | "membership" | "%future added value";
export type CreateProductAppInput = {
  allowPostsFrom?: FeedAllowPostsFrom | null;
  allowPostsGroups?: ReadonlyArray<string> | null;
  allowPostsMembers?: ReadonlyArray<string> | null;
  appDirectoryItems?: ReadonlyArray<AppDirectoryItemInput> | null;
  badge?: BadgeInput | null;
  contentId?: string | null;
  contentLabelId?: string | null;
  contentType?: ContentType | null;
  coverPhoto?: string | null;
  customAppDescription?: string | null;
  customAppTitle?: string | null;
  customAppUrl?: string | null;
  dashboardLayout?: DashboardLayout | null;
  kind: ProductAppKind;
  linkProductId?: string | null;
  navFolderId?: string | null;
  navSectionId?: string | null;
  organizationId?: string | null;
  productId?: string | null;
  richEditorContent?: string | null;
  showOnDashboard?: boolean | null;
  skipDefaultModule?: boolean | null;
  systemTaskKind?: ContentSystemTaskKind | null;
  visibility?: ProductAppVisibility | null;
  visibilityGroups?: ReadonlyArray<string> | null;
  visibilityMembers?: ReadonlyArray<string> | null;
};
export type BadgeInput = {
  assetId?: string | null;
  color?: string | null;
  emoji?: string | null;
  icon?: string | null;
  kind: BadgeKind;
  mediaUrl?: string | null;
};
export type AppDirectoryItemInput = {
  memberGroupId: string;
};
export type useAddAppMutation$variables = {
  input: CreateProductAppInput;
  isCurriculumApp: boolean;
  isEventsApp: boolean;
  isOrgTopLevel: boolean;
  kind: ProductAppKind;
};
export type useAddAppMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly customAppTitle: string | null;
      readonly customAppUrl: string | null;
      readonly feed: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly kind: ProductAppKind;
      readonly navSection: {
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_NavSectionFragment">;
      } | null;
      readonly ordering: number;
      readonly organization: {
        readonly viewerMembership?: {
          readonly " $fragmentSpreads": FragmentRefs<"useViewerCanCreateEventsFragment">;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_OrganizationFragment">;
      };
      readonly product: {
        readonly curriculum?: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ContentModuleUtils_useCurriculumModuleIdsFragment">;
        } | null;
        readonly hasProductApp: boolean;
        readonly productApps: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            };
          }>;
        };
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_ProductFragment" | "MyExperiencesListItemFragment">;
      } | null;
      readonly showOnDashboard: boolean;
      readonly status: ProductAppStatus;
    } | null;
  };
};
export type useAddAppMutation = {
  response: useAddAppMutation$data;
  variables: useAddAppMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCurriculumApp"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEventsApp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOrgTopLevel"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kind"
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showOnDashboard",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "kind",
      "variableName": "kind"
    }
  ],
  "kind": "ScalarField",
  "name": "hasProductApp",
  "storageKey": null
},
v14 = [
  (v6/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Feed",
  "kind": "LinkedField",
  "name": "feed",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v25 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v26 = [
  (v25/*: any*/),
  (v24/*: any*/)
],
v27 = {
  "alias": "nullableProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v28 = [
  (v27/*: any*/),
  (v24/*: any*/)
],
v29 = {
  "alias": "nullableProductIdString",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Feed",
  "kind": "LinkedField",
  "name": "feed",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v17/*: any*/),
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v22/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v24/*: any*/)
          ],
          "type": "Product",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v26/*: any*/),
          "type": "Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v28/*: any*/),
          "type": "Comment",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v28/*: any*/),
          "type": "Feed",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v28/*: any*/),
          "type": "Post",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v29/*: any*/),
            (v24/*: any*/)
          ],
          "type": "ContentUsage",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v28/*: any*/),
          "type": "ChatChannel",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v28/*: any*/),
          "type": "Dashboard",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v26/*: any*/),
          "type": "AssignmentSubmission",
          "abstractKey": null
        }
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "storageKey": null
},
v31 = [
  (v21/*: any*/)
],
v32 = [
  (v25/*: any*/),
  (v21/*: any*/),
  (v24/*: any*/)
],
v33 = [
  (v27/*: any*/),
  (v21/*: any*/),
  (v24/*: any*/)
],
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v31/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v23/*: any*/),
        (v21/*: any*/),
        (v24/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v33/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v33/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v33/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v29/*: any*/),
        (v21/*: any*/),
        (v24/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v33/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v33/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v31/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v31/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v17/*: any*/),
    (v34/*: any*/),
    (v6/*: any*/),
    (v20/*: any*/),
    {
      "alias": "connectedApps",
      "args": [
        {
          "kind": "Literal",
          "name": "includeNested",
          "value": true
        }
      ],
      "concreteType": "ProductAppNodeConnection",
      "kind": "LinkedField",
      "name": "productApps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductAppNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductApp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v7/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "productApps(includeNested:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": (v14/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsage",
  "kind": "LinkedField",
  "name": "contentUsage",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChannelId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "productApps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatChannel",
              "kind": "LinkedField",
              "name": "chatChannel",
              "plural": false,
              "selections": [
                (v39/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v40/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "forYouDashboard",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "navSectionId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannel",
  "kind": "LinkedField",
  "name": "chatChannel",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v39/*: any*/),
    (v34/*: any*/),
    (v43/*: any*/),
    (v45/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductAppNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductApp",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v11/*: any*/),
          (v10/*: any*/),
          (v30/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v8/*: any*/),
          (v43/*: any*/),
          (v19/*: any*/),
          (v44/*: any*/),
          (v45/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      (v48/*: any*/)
    ],
    "storageKey": null
  },
  (v49/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddAppMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v5/*: any*/),
        "concreteType": "CreateProductAppResponse",
        "kind": "LinkedField",
        "name": "createProductApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductApp",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MyExperiencesListItemFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AppsSidebarList_ProductFragment"
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeConnection",
                    "kind": "LinkedField",
                    "name": "productApps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductAppNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "isCurriculumApp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Curriculum",
                        "kind": "LinkedField",
                        "name": "curriculum",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ContentModuleUtils_useCurriculumModuleIdsFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  {
                    "condition": "isEventsApp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationMembership",
                        "kind": "LinkedField",
                        "name": "viewerMembership",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "useViewerCanCreateEventsFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isOrgTopLevel",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AppsSidebarList_OrganizationFragment"
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NavSection",
                "kind": "LinkedField",
                "name": "navSection",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AppsSidebarList_NavSectionFragment"
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAddAppMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v5/*: any*/),
        "concreteType": "CreateProductAppResponse",
        "kind": "LinkedField",
        "name": "createProductApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductApp",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "organizationMembershipId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Dashboard",
                        "kind": "LinkedField",
                        "name": "forYouDashboard",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "app",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "waitingRoomEndsAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminCanLearnMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeConnection",
                    "kind": "LinkedField",
                    "name": "productApps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductAppNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v11/*: any*/),
                              (v10/*: any*/),
                              (v30/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v8/*: any*/),
                              (v43/*: any*/),
                              (v19/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              {
                                "alias": "folderApps",
                                "args": null,
                                "concreteType": "ProductAppNodeConnection",
                                "kind": "LinkedField",
                                "name": "productApps",
                                "plural": false,
                                "selections": (v50/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": "folderApps",
                                "args": null,
                                "filters": null,
                                "handle": "connection",
                                "key": "AppsSidebarList_ProductFragment__folderApps",
                                "kind": "LinkedHandle",
                                "name": "productApps"
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v49/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "AppsSidebarList_ProductFragment__productApps",
                    "kind": "LinkedHandle",
                    "name": "productApps"
                  },
                  (v13/*: any*/),
                  (v34/*: any*/),
                  {
                    "condition": "isCurriculumApp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Curriculum",
                        "kind": "LinkedField",
                        "name": "curriculum",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeConnection",
                            "kind": "LinkedField",
                            "name": "modules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsageNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsage",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isReleased",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "contentId",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "condition": "isEventsApp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationMembership",
                        "kind": "LinkedField",
                        "name": "viewerMembership",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "adminMembershipsWithEventApps",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "appKind",
                                "value": "events"
                              },
                              {
                                "kind": "Literal",
                                "name": "productType",
                                "value": "course"
                              },
                              {
                                "kind": "Literal",
                                "name": "roles",
                                "value": [
                                  "manager",
                                  "instructor"
                                ]
                              }
                            ],
                            "concreteType": "ProductMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "productMemberships",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/)
                            ],
                            "storageKey": "productMemberships(appKind:\"events\",productType:\"course\",roles:[\"manager\",\"instructor\"])"
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isOrgTopLevel",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v51/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "filters": null,
                        "handle": "connection",
                        "key": "AppsSidebarList_OrganizationFragment__apps",
                        "kind": "LinkedHandle",
                        "name": "apps"
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NavSection",
                "kind": "LinkedField",
                "name": "navSection",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "AppsSidebarList_NavSectionFragment__apps",
                    "kind": "LinkedHandle",
                    "name": "apps"
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0993cb1d511642216602c58bd52e7118",
    "id": null,
    "metadata": {},
    "name": "useAddAppMutation",
    "operationKind": "mutation",
    "text": "mutation useAddAppMutation(\n  $input: CreateProductAppInput!\n  $isCurriculumApp: Boolean!\n  $isEventsApp: Boolean!\n  $kind: ProductAppKind!\n  $isOrgTopLevel: Boolean!\n) {\n  response: createProductApp(input: $input) {\n    node {\n      id\n      kind\n      status\n      ordering\n      customAppTitle\n      customAppUrl\n      showOnDashboard\n      product {\n        ...MyExperiencesListItemFragment\n        ...AppsSidebarList_ProductFragment\n        hasProductApp(kind: $kind)\n        productApps {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        curriculum @include(if: $isCurriculumApp) {\n          id\n          ...ContentModuleUtils_useCurriculumModuleIdsFragment\n        }\n        id\n      }\n      organization {\n        viewerMembership @include(if: $isEventsApp) {\n          ...useViewerCanCreateEventsFragment\n          id\n        }\n        ...AppsSidebarList_OrganizationFragment @include(if: $isOrgTopLevel)\n        id\n      }\n      navSection {\n        ...AppsSidebarList_NavSectionFragment\n        id\n      }\n      feed {\n        id\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AppSidebarItemFragment on ProductApp {\n  kind\n  status\n  visibility\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  forYouDashboard {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment AppsSidebarDragDropProvider_OrganizationFragment on Organization {\n  id\n  forYouDashboard {\n    app {\n      id\n    }\n    id\n  }\n}\n\nfragment AppsSidebarList_NavSectionFragment on NavSection {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AppsSidebarList_OrganizationFragment on Organization {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AppsSidebarList_ProductFragment on Product {\n  id\n  productApps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        folderApps: productApps {\n          edges {\n            node {\n              id\n              kind\n              customAppUrl\n              customAppTitle\n              feed {\n                id\n                name\n                viewerPermissions\n                ...usePermissionsFragment\n              }\n              product {\n                slug\n                name\n                ...usePermissionsFragment\n                ...appLevelContextFragment\n                id\n              }\n              collection {\n                id\n              }\n              contentUsage {\n                id\n              }\n              linkProduct {\n                slug\n                id\n              }\n              productApps {\n                edges {\n                  node {\n                    id\n                    chatChannel {\n                      externalChannelId\n                      id\n                    }\n                  }\n                }\n              }\n              forYouDashboard {\n                id\n              }\n              ...AppSidebarItemFragment\n              ...ContentAppSettingsButtonFragment\n              ...LinkAppSettingsButtonFragment\n              ...FeedAppSettingsButtonFragment\n              ...GenericAppSettingsButtonFragment\n              ...CollectionAppSettingsButtonFragment\n              ...ChatChannelSettingsModalButtonFragment\n              ...ChatChannelSideBarItemFragment\n              ...NavFolderSettingsDropdownFragment\n              ...EventsAppSettingsButtonFragment\n              ...MembersAppSettingsButtonFragment\n              ...DashboardAppSettingsButtonFragment\n              ...AppUtils_getLocationFragment\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment CollectionAppSettingsButtonFragment on ProductApp {\n  id\n  ...CollectionAppSettingsModalFragment\n}\n\nfragment CollectionAppSettingsModalFragment on ProductApp {\n  id\n}\n\nfragment ContentAppSettingsButtonFragment on ProductApp {\n  id\n  ...ContentAppSetupModalFragment\n}\n\nfragment ContentAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment ContentModuleUtils_useCurriculumModuleIdsFragment on Curriculum {\n  id\n  modules {\n    edges {\n      node {\n        id\n        isReleased\n        contentId\n      }\n    }\n  }\n}\n\nfragment DashboardAppSettingsButtonFragment on ProductApp {\n  id\n  ...DashboardAppSetupModalFragment\n}\n\nfragment DashboardAppSetupModalContentFragment on ProductApp {\n  id\n  forYouDashboard {\n    id\n  }\n}\n\nfragment DashboardAppSetupModalFragment on ProductApp {\n  customAppTitle\n  forYouDashboard {\n    id\n  }\n  ...DashboardAppSetupModalContentFragment\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment DeleteNavFolderButtonFragment on ProductApp {\n  id\n  customAppTitle\n  productApps {\n    totalCount\n  }\n}\n\nfragment EventsAppSettingsButtonFragment on ProductApp {\n  id\n  ...EventsAppSetupModalFragment\n}\n\nfragment EventsAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment ExperienceAdminDropdownFragment on Product {\n  id\n  slug\n  type\n  name\n  adminCanLearnMode\n  ...LearnModeSwitchFragment\n  ...usePermissionsFragment\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment GenericAppSettingsButtonFragment on ProductApp {\n  id\n  ...GenericAppSettingsModalFragment\n}\n\nfragment GenericAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment LeaveProductButtonFragment on Product {\n  name\n  slug\n  type\n  viewerMembership {\n    id\n    organizationMembershipId\n  }\n}\n\nfragment LinkAppSettingsButtonFragment on ProductApp {\n  id\n  ...LinkAppSetupModalFragment\n}\n\nfragment LinkAppSetupModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MemberDirectoryAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MembersAppSettingsButtonFragment on ProductApp {\n  id\n  kind\n  productId\n  ...MemberDirectoryAppSettingsModalFragment\n}\n\nfragment MyExperiencesListItemFragment on Product {\n  id\n  name\n  slug\n  status\n  viewerMembership {\n    id\n  }\n  organization {\n    ...AppsSidebarDragDropProvider_OrganizationFragment\n    id\n  }\n  ...ProductBadgeFragment\n  ...usePermissionsFragment\n  ...useIsWaitingRoomEnabledActiveProductFragment\n  ...ExperienceAdminDropdownFragment\n  ...LeaveProductButtonFragment\n  ...LearnModeSwitchFragment\n}\n\nfragment NavFolderSettingsButtonFragment on ProductApp {\n  id\n}\n\nfragment NavFolderSettingsDropdownFragment on ProductApp {\n  id\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  ...NavFolderSettingsButtonFragment\n  ...DeleteNavFolderButtonFragment\n}\n\nfragment ProductBadgeFragment on Product {\n  id\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment appLevelContextFragment on Product {\n  id\n  name\n  slug\n  type\n  ...useConnectedProductAppsActiveProductFragment\n}\n\nfragment useConnectedProductAppsActiveProductFragment on Product {\n  connectedApps: productApps(includeNested: true) {\n    edges {\n      node {\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment useIsWaitingRoomEnabledActiveProductFragment on Product {\n  waitingRoomEndsAt\n  startDate\n  ...usePermissionsFragment\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n\nfragment useViewerCanCreateEventsFragment on OrganizationMembership {\n  adminMembershipsWithEventApps: productMemberships(roles: [manager, instructor], productType: \"course\", appKind: events) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3e745fb971b8f0e6a83407a30b5031a";

export default node;
